import ScreenRole from "./screen-role"

interface Screen {
    id: string
    name: string
    url: string
    code: string
    description: string,
    createdAt: Date,
    updatedAt: Date,
    moduleOrder: number,
    screenRoles?: ScreenRole[]
    hide: boolean
    deletedAt?: Date | null
}


export enum SCREENS {

    // Human Resources
    HR_EMPLOYEES = "SC_HR_EP_001",
    HR_CONSULTANTS = "SC_HR_CO_002",
    HR_EMERGENCY_CONTACTS = "SC_HR_EC_003",
    HR_DEMOGRAPHICS = "SC_HR_DM_004",
    HR_ORG_CHART = "SC_HR_OC_005",
    HR_DOCUMENT_GENERATOR = "SC_HR_DG_006",
    HR_DOCUMENT_APPROVER = "SC_HR_AP_008",
    HR_DASHBOARD = "SC_HR_DB_007",
    HR_RETENTION = "SC_HR_RT_009",
    HR_ANNIVERSARY = "SC_HR_AN_010",
    HR_ADMIN = "SC_HR_AD_0011",

    // Executive
    EXECUTIVE_ACTIVE_PROJECTS = "SC_EX_AP_001",
    EXECUTIVE_WORK_IN_PROGRESS = "SC_EX_WP_002",
    EXECUTIVE_DASHBOARD = "SC_EX_WP_003",

    // Business Development
    BD_OPPORTUNITIES = "SC_BD_OP_001",
    BD_DASHBAORD = 'SC_BD_DB_002',
    BD_ROCKS = "SC_BD_RK_003",
    BD_INDUSTRY_ENGAGEMENT = "SC_BD_IE_004",
    BD_CLIENT_ENGAGEMENT = "SC_BD_CE_005",
    BD_CUSTOMERS = "SC_BD_CS_006",

    // Finance
    FINANCE_BRM = "SC_FN_BRM_001",
    FINANCE_CALENDAR = "SC_FN_FC_002",
    FINANCE_DASHBOARD = "SC_FN_DB_004",
    FINANCE_BUDGET_ACTUALS = 'SC_FN_BA_003',
    FINANCE_FINANCIAL_KPI = "SC_FN_FK_004",
    FINANCE_DEPARTMENT_BUDGETS = "SC_FN_BG_005",
    FINANCE_DEPARTMENT_GROSS_MARGIN_REPORT = "SC_FN_GR_006",
    FIN_ADMIN = "SC_FN_AD_010",
    FINANCE_EXPENSE_BUDGETS = "SC_FN_EB_011",
    FINANCE_FINANCIAL_KPI_SNAPSHOT = "SC_FN_FS_012",

    // Admin
    ADMIN_USERS = "SC_AD_US_001",
    ADMIN_ROLES = "SC_AD_RO_002",
    ADMIN_DASHBOARD = "SC_AD_DB_003",
    ADMIN_GOOGLE_ANALYTICS = "SC_AD_AN_004",
    ADMIN_DEPARTMENT_LEVELS = "SC_AD_DL_005",
    ADMIN_DEPARTMENTS = "SC_AD_DP_006",
    ADMIN_DEPARTMENT_KPIS = "SC_AD_DK_011",
    ADMIN = "SC_AD_AD_008",
    ADMIN_FISCAL_YEARS = "SC_AD_FY_009",
    ADMIN_LAMBDA_TRACKER = "SC_AD_LT_011",
    ADMIN_SYSTEM_UPDATES_MEMO = "SC_AD_SU_012",
    ADMIN_REGION_MAPPING = "SC_AD_RM_013",
    ADMIN_CLIENT_MAPPING = "SC_AD_CM_014",

    // Projects
    PROJECT_MANAGMENT_DASHBOARD = "SC_PM_DB_001",
    PROJECT_MANAGMENT_PROJECTS = "SC_PM_PJ_002",
    PROJECT_MANAGMENT_PROJECT_PROFITABILITY = "SC_PM_PP_003",
    PROJECT_MANAGMENT_PROJECT_FORECAST = "SC_PM_PF_004",
    PROJECT_MANAGMENT_OPPORTUNITY_FORECAST = "SC_PM_OF_005",
}


export default Screen